// 发布页-更多参数半层页
export default {
  routes: [
    {
      path: '/publishMoreParameter',
      name: 'publishMoreParameter',
      meta: {
        title: '更多参数'
      },
      component: () =>
        import(
          /* webpackChunkName: "publishMoreParameter" */ '../views/publishMoreParameter/index.vue'
        )
    }
  ]
}
